import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";
import { isMixedModelTypeGuard } from "@/utils/artistInstrumentModelMixedModel/is/isMixedModelTypeGuard";
import { isModelTypeGuard } from "@/utils/artistInstrumentModelMixedModel/is/isModelTypeGuard";

// Custom models and mixed models carry their own presigned URL; built-in artists and instruments have none.
export const getPresignedUrlModelMixedModel = (
  artistInstrumentModelMixedModel:
    | Artist
    | Instrument
    | ModelNoDates
    | MixedModelConstructedNoDates
    | null
): ModelNoDates["presignedUrlModel"] | null => {
  if (artistInstrumentModelMixedModel === null) {
    return null;
  }
  if (isModelTypeGuard(artistInstrumentModelMixedModel)) {
    return artistInstrumentModelMixedModel.presignedUrlModel;
  }
  if (isMixedModelTypeGuard(artistInstrumentModelMixedModel)) {
    return artistInstrumentModelMixedModel.presignedUrlMixedModel;
  }
  return null;
};
